import { create } from 'zustand'

export type Payload = {
  firstName: string
  lastName: string
  email: string
  role: string
  id: string
}

type AuthState = {
  isLoading: boolean
  payload: Payload | null
  setLoading: (loading: boolean) => void
  setPayload: (payload: Payload | null) => void
  clearAuth: () => void
  logout: () => void
}

export const useAuth = create<AuthState>()((set, get) => ({
  isLoading: true,
  payload: null,

  setLoading: (loading: boolean) => {
    set({ isLoading: loading })
  },

  setPayload: (payload: Payload | null) => {
    set({
      payload,
      isLoading: false,
    })
  },

  clearAuth: () => {
    set({
      payload: null,
      isLoading: false,
    })
  },

  logout: () => {
    get().clearAuth()
  },
}))
